export default __webpack_public_path__ + "static/media/logo-spacerace.27239bdf.png";